import { render, staticRenderFns } from "./XmStepIcon.vue?vue&type=template&id=59f48810&scoped=true"
import script from "./XmStepIcon.vue?vue&type=script&lang=js"
export * from "./XmStepIcon.vue?vue&type=script&lang=js"
import style0 from "./XmStepIcon.vue?vue&type=style&index=0&id=59f48810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f48810",
  null
  
)

export default component.exports